// extracted by mini-css-extract-plugin
export default {"header":"Addresses_header__7f1qD","next":"Addresses_next__045Fd","add_address":"Addresses_add_address__gRheZ","add_icon":"Addresses_add_icon__o2okH"};